import { ApplyBrand } from '@app/utils/models/apply-brand.model';
import { BrandType } from '@ess-front/shared/models';

export const APPLY_BRANDS: ApplyBrand[] = [
  { brand: BrandType.LATAM, param: 'latam' },
  { brand: BrandType.VISA, param: 'visaap' },
];
